import { JxtTagColorsEnum } from '@jooxter/utils';
import { ReactNode } from 'react';

export enum JxtHomeAgendaItemKindEnum {
  Meeting = 'meeting',
  /** Desk or parking: green bar, type icon before the title. */
  Space = 'space',
}

export interface IJxtHomeAgendaItemTag {
  label: string;
  /** Font Awesome icon name, e.g. "location-crosshairs". */
  icon: string;
  tone: JxtTagColorsEnum;
  /** On hover (and for screen readers), what the short label stands for, e.g. "Overlaps Q4 roadmap". */
  hint?: string;
}

export interface IJxtHomeAgendaItem {
  /** e.g. "4:30 PM". */
  start: string;
  end: string;
  kind: JxtHomeAgendaItemKindEnum;
  /** Font Awesome icon name before the title (desks and parkings), e.g. "chair". */
  titleIcon?: string;
  title: string;
  /** Opens the booking detail. */
  onTitleClick: () => void;
  titleHint: string;
  /** Resource, floor, participants, who invites… */
  details: string;
  tag?: IJxtHomeAgendaItemTag;
  /** Quick actions (small JxtButton). */
  actions?: ReactNode;
  /** Finished: greyed out. */
  muted?: boolean;
  /** A meeting in progress: lightly tinted. */
  highlighted?: boolean;
}
